import * as React from "react"

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> & {
    label: React.ReactNode
    error?: string
}

export const CheckboxField = React.forwardRef<HTMLInputElement, Props>(
    function CheckboxField({ label, error, id, ...props }, ref) {
        const generatedId = React.useId()
        const inputId = id ?? generatedId

        return (
            <div className="space-y-2">
                <div className="flex items-start gap-3">
                    <input
                        ref={ref}
                        id={inputId}
                        type="checkbox"
                        className="mt-0.5 h-4 w-4 rounded-md bg-white shadow-(--shadow-sm) accent-accent"
                        {...props}
                    />
                    <label htmlFor={inputId} className="text-sm leading-relaxed text-muted">
                        {label}
                    </label>
                </div>
                {error ? (
                    <p className="text-xs text-[color-mix(in_oklab,var(--color-accent-2),black_18%)]">
                        {error}
                    </p>
                ) : null}
            </div>
        )
    }
)